import { useContext, useEffect, useState } from 'react';
import { Context as AuthContext } from '../contexts/AuthContext';
import SupportService from '../services/Support';

export const SUPPORT_ATTACHMENT_ACCEPT =
  'image/jpeg,image/png,application/pdf,video/mp4,video/quicktime,video/webm,.png,.jpg,.jpeg,.pdf,.mp4,.mov,.webm';
export const DEFAULT_SUPPORT_ATTACHMENT_MAX_SIZE_MB = 10;

export const findOversizedAttachment = (files: File[], maxSizeMb: number): File | undefined =>
  files.find((file) => file.size > maxSizeMb * 1024 * 1024);

export function useSupportAttachmentConfig(schoolId?: string) {
  const { token }: any = useContext(AuthContext);
  const [maxSizeMb, setMaxSizeMb] = useState(DEFAULT_SUPPORT_ATTACHMENT_MAX_SIZE_MB);

  useEffect(() => {
    if (!token || !schoolId) {
      setMaxSizeMb(DEFAULT_SUPPORT_ATTACHMENT_MAX_SIZE_MB);
      return undefined;
    }

    let cancelled = false;
    (async () => {
      try {
        const result = await SupportService(token).attachmentConfig(schoolId);
        const size = Number(result?.data?.maxSizeMb);
        if (!cancelled && size) {
          setMaxSizeMb(size);
        }
      } catch {
        if (!cancelled) {
          setMaxSizeMb(DEFAULT_SUPPORT_ATTACHMENT_MAX_SIZE_MB);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [token, schoolId]);

  return { maxSizeMb, accept: SUPPORT_ATTACHMENT_ACCEPT };
}

export default useSupportAttachmentConfig;
